import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TableCellBase } from '../../Table'
import { TaskStatusType } from '../Task.enums'
import { isTaskStatusTypeNo, isTaskStatusTypeYes } from '../Task.utils'
import { TaskStatusToggle } from '../TaskStatusToggle'

import {
  getTaskTableRowYesNoStatusNextValue,
  getTaskTableRowYesNoStatusQaName,
} from './TaskTableRowYesNoStatus.utils'

import * as styles from './TaskTableRowYesNoStatus.module.css'

function TaskTableRowYesNoStatus({
  disabled,
  isLoading,
  item,
  onChange,
  ...restProps
}) {
  const { yesno } = item

  const { t } = useTranslation()

  const [loadingType, setLoadingType] = useState(null)

  function getHandleChange(type) {
    return () => {
      setLoadingType(type)

      const nextValue = getTaskTableRowYesNoStatusNextValue(yesno, type)

      onChange?.({ yesno: nextValue }).finally(() => {
        setLoadingType(null)
      })
    }
  }

  return (
    <TableCellBase {...restProps}>
      <div className={styles.container}>
        <TaskStatusToggle
          checked={isTaskStatusTypeYes(yesno)}
          disabled={disabled || isLoading}
          isLoading={isTaskStatusTypeYes(loadingType)}
          qaName={getTaskTableRowYesNoStatusQaName(TaskStatusType.Yes)}
          text={t('TaskTable.StatusYesKey')}
          tooltip={t(
            isTaskStatusTypeYes(yesno)
              ? 'TaskTable.ActionMarkAsOpenTooltipKey'
              : 'TaskTable.ActionMarkAsDoneTooltipKey'
          )}
          type={TaskStatusType.Yes}
          onChange={getHandleChange(TaskStatusType.Yes)}
        />
        <TaskStatusToggle
          checked={isTaskStatusTypeNo(yesno)}
          disabled={disabled || isLoading}
          isLoading={isTaskStatusTypeNo(loadingType)}
          qaName={getTaskTableRowYesNoStatusQaName(TaskStatusType.No)}
          text={t('TaskTable.StatusNoKey')}
          tooltip={t(
            isTaskStatusTypeNo(yesno)
              ? 'TaskTable.ActionMarkAsOpenTooltipKey'
              : 'TaskTable.ActionMarkAsDoneTooltipKey'
          )}
          type={TaskStatusType.No}
          onChange={getHandleChange(TaskStatusType.No)}
        />
      </div>
    </TableCellBase>
  )
}

export default TaskTableRowYesNoStatus
